<svelte:head>
  <title>cloudsinc - Reconcile Everything</title>
  <link rel='icon' type='image/x-icon' href='/images/cloudsinc-logo-transparent-4pxline{ location.href.indexOf("localhost") != -1 ? "-local": ""}.png'>
  <script src="https://use.fontawesome.com/releases/v5.15.1/js/all.js" crossorigin="anonymous"></script>
  <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css" />
  <link href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic" rel="stylesheet" type="text/css" />
  <link href="css/styles.css" rel="stylesheet" />
  <link href="css/app.css" rel="stylesheet" />
  <!-- XXX add to package.json to track versions/vuln -->
  <script language="JavaScript" type="text/javascript" src="https://kjur.github.io/jsrsasign/jsrsasign-latest-all-min.js">
  </script>
  <!-- <script src="js/verifier.js"></script>
  <script src="js/userprofile.js"></script> -->

  <script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>

</svelte:head>

<script lang="ts">

// var s="+++++++++++++++++++++++++++++++++++++++++++++++++++";
// console.loglog = console.log;
// console.log = function() { 
//   console.loglog.apply(null,[s.substring(0,console.indent||0), ...arguments]); 
// }  
// console.go = (msg,func) => {
//   console.log(msg); 
//   console.indent = (console.indent||0)+2; 
//   var ret;
//   try { ret = func(); }
//   finally { console.indent -= 2; return ret;}  
// }

import AppHeadNav from "./AppHeadNav.svelte";
import Workspace from "./Workspace.svelte"
import IdentityDebug from "./IdentityDebug.svelte"
import { Row } from "sveltestrap";
import { Button } from 'sveltestrap';


import {ensureLoggedIn} from './js/userprofile.js';
import {from, auth} from './from.js';
import {msg, showMsg, clearMsg} from './shared';
import {global} from './state.js';

// var state = {
//   openrecs: []
// };

var identityDebug = location.href.indexOf("identityDebug") > -1;

var loggedIn = false;

function loggedInCallback(tokens) {
  auth.tokens = tokens;
  loggedIn = true;
}

var terms = false;
var privacy = false;

function accept() {
  if (terms && privacy) {
    from("/accept", {method:"POST"}).then(r=>r.json())
    .then(r => {
      console.log("got accept response", r)
      global.env.accepted = true;
    })
    .catch((ex)=>{
      console.log("accept err", ex)
      showMsg("Error occurred.");
    });
  }
}

const urlParams = new URLSearchParams(location.search);
global.noauth  = urlParams.get("noauth") === "true";

if (global.noauth) {
  console.log("noauth mode", [...urlParams.keys()])
  const urldata = urlParams.get("data")
  if (urldata) {
    let json;
    if (urldata && urldata[0] !== '{') {
      // json = Buffer.from(urldata, 'base64').toString();
      json = atob(urldata.replace(/_/g, '/').replace(/-/g, '+'))
    } else {
      json = urldata;
    }
    global.bootRec = JSON.parse(json); 
  } else if (urlParams.get("uriA") && urlParams.get("uriB")) {
    global.bootRec = { uriA:urlParams.get("uriA"), uriB:urlParams.get("uriB"), email: urlParams.get("email")}
  }
  console.log("App.bootRec", global.bootRec)
}

from("/env"+window.location.search, {})
.then(r=>r.json())
.then(r => {
  // console.log("got env", r)
  global.env = r;
  window["env"] = r;
})
.finally(()=>{
  // console.log("finally env", global.env)
  if (!global.noauth && "testing" !== global.env.name) {
    ensureLoggedIn(global.env, loggedInCallback);
  } else {
    loggedInCallback({});
  }
})

$: showLoading = !loggedIn;
</script>
<style>
  .loading {
    width: 8rem;
    font-size: 2rem;
    margin: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    color: #999;
  }

  .accept {
    width: 40rem;
    font-size: 1rem;
    margin: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    color: #999;
  }

  .problem {
    font-size: 1rem;
  }

  .problem a { 
    display: inline;
  }
</style>

{#if showLoading }

<section class="page-section " >
  <div class="container-fluid loading">
    <h2 class="page-section-heading text-center text-uppercase text-secondary mb-0">Loading...</h2>
    <div class='problem'>Problem?&nbsp;<a href="/app.html">Restart</a>
  </div>
</section>


{:else if !global.env.accepted }

<section class="page-section " >
  <div class="container-fluid accept">
    One more thing..
    <div><input type=checkbox bind:checked={terms}  > I have read and agree to the <a href="/terms.html">terms and conditions</a>.</div>
    <div><input type=checkbox bind:checked={privacy}> I have read and agree to the <a href="/privacy.html">privacy statement</a>.</div>
    <div>
      <Button on:click={()=>accept()} disabled={!(terms && privacy)} class='sm'>Continue</Button>
    </div>
  </div>
</section>

{:else}
 
<AppHeadNav />

<section class="page-section " >
  <div class="container-fluid">
    <h2 class="h2 text-center text-uppercase text-secondary mb-0 mt-1">
    {#if $msg.msg} 
      {$msg.msg}
    {:else} 
      &nbsp;
    {/if}
    </h2>
    <Workspace on:message={showMsg} on:clear={clearMsg} />
  </div>
</section>
{/if}

{#if identityDebug}
<Row>
  <div class='col-sm'>
    <IdentityDebug />
  </div>
</Row>
{/if}
